// extracted by mini-css-extract-plugin
export default {"wrapper":"CoJfgJEEPp","themeToggle":"AnUwIfKIIM","light":"KEwuI0jiRk","dark":"TEF57Yop6I","triangle":"fDnAeiOeVG"};